exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sc-comparison-table-column-rows[data-v-5bfe70d3]>:nth-child(odd){background:#eef7ff}.highlight[data-v-5bfe70d3]{border:1px solid rgba(181,194,201,.6);-webkit-box-shadow:0 0 5px 3px rgba(176,190,197,.3);box-shadow:0 0 5px 3px rgba(176,190,197,.3);z-index:1}", ""]);

// exports
